import { Pipe, PipeTransform } from '@angular/core';
import { translateAccessGroupCarType } from '../mappers/enum-translation-mapper';
import { AccessGroupCarType } from '../enums/access-group-car-type';

@Pipe({
  name: 'translateAccessGroupCarTypeEnum',
})
export class TranslateAccessGroupCarTypeEnum implements PipeTransform {
  transform(value: any): any {
    if (Array.isArray(value)) {
      value.forEach(element => {
        const problemTypeEnum = element as { name: any; index: any };
        problemTypeEnum.name = translateAccessGroupCarType(problemTypeEnum.index);
      });
      return value;
    } else {
      const enumValue: AccessGroupCarType = AccessGroupCarType[value as keyof typeof AccessGroupCarType];
      return translateAccessGroupCarType(enumValue);
    }
  }
}
